import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ExamsPageData {
  readyStatus: "invalid" | "request" | "success" | "failure";
  slug: string;
  data: any;
  relatedPosts: any[];
}

export const initialState: ExamsPageData = {
  readyStatus: "invalid",
  slug: "",
  data: null,
  relatedPosts: [],
};

const examsPageSlice = createSlice({
  name: "examsPageData",
  initialState,
  reducers: {
    updateExamsData: (state: ExamsPageData, { payload }: PayloadAction<any>) => {
      state.data = payload?.data || null;
      state.slug = payload?.slug || "";
      state.relatedPosts = payload?.relatedPosts || [];
      state.readyStatus = "success";
    },
    updateExamsReadyStatus: (
      state: ExamsPageData,
      { payload }: PayloadAction<"invalid" | "request" | "success" | "failure">,
    ) => {
      state.readyStatus = payload;
    },
    resetExamsData: (state: ExamsPageData) => {
      state.readyStatus = "invalid";
      state.data = null;
      state.slug = "";
      state.relatedPosts = [];
    },
  },
});

export const { updateExamsData, updateExamsReadyStatus, resetExamsData } = examsPageSlice.actions;

export default examsPageSlice.reducer;

export const shouldFetchExams = (examsPageDataState: ExamsPageData, slug: string) =>
  examsPageDataState.readyStatus === "invalid" || examsPageDataState.slug !== slug;
